import { Col, Row, Space, Typography, Modal, Dropdown, message } from "antd";
import CategoriesView from "../components/CategoriesView";
import { useState } from "react";
import CategoriesFormDialog from "../components/CategoriesFormDialog";
import { Category } from "../repository/data.default";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getCategoriesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function CategoriesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [categoriesInputMode, setCategoriesInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [categoriesInputOpen, setCategoriesInputOpen] = useState(false);
  const [categoriesInputValues, setCategoriesInputValues] = useState<Category>(
    {} as any,
  );
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onCategoriesInputOpen(
    mode: "add" | "update" | "delete",
    values?: Category,
  ): void {
    setCategoriesInputMode(mode);
    setCategoriesInputOpen(true);
    setCategoriesInputValues(values || ({} as any));
  }

  function onCategoriesInputFinish(): void {
    setCategoriesInputOpen(false);
    setCategoriesInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onCategoriesInputClose(): void {
    setCategoriesInputOpen(false);
    setCategoriesInputValues({} as any);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading categories export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getCategoriesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Categories
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("TemplatesCategories", "create")}

            className={`${!permissions.can("TemplatesCategories", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("TemplatesCategories", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onCategoriesInputOpen("add")}
          >
            Add Category
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <CategoriesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onCategoriesInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <CategoriesFormDialog
        key={categoriesInputMode}
        mode={categoriesInputMode}
        open={categoriesInputOpen}
        initialValues={categoriesInputValues}
        onFinish={onCategoriesInputFinish}
        onCancel={onCategoriesInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default CategoriesPage;
